// The fallback control shown while navigation is active and location
// permission was denied or unavailable at the start tap (R-SAFE-01: no
// second geolocation path — this asks again, through the same
// BrowserGeolocation adapter, only on this explicit tap). The confirmation
// card that follows (glasses-screen-specs-2026-09-28.md section 7) is wired
// in NavigationOverlay.tsx, off the same `shared` transition.
//
// It is the only action on screen when it appears, so it takes focus itself
// on arrival (style guide: "a lone action starts focused") rather than
// relying on ChipRow's focus wiring, which never sees this button.
import { useEffect, useRef } from 'react';

export interface ShareLocationButtonProps {
  onShare: () => void;
}

export default function ShareLocationButton({ onShare }: ShareLocationButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    buttonRef.current?.focus();
  }, []);

  return (
    <button ref={buttonRef} type="button" className="mu-nav-share focusable" aria-label="On my way" onClick={onShare}>
      {/* Filled teardrop, 32 wide by 44 tall, with a round knockout near the
          top (spec section 7). Filled because an outline at this size would
          fall below the 3px line floor. */}
      <svg className="mu-nav-share-pin" width="32" height="44" viewBox="0 0 32 44" aria-hidden="true">
        <path
          d="M16 0C7.2 0 0 7.1 0 15.8 0 27.4 14.2 42.6 15 43.4a1.4 1.4 0 0 0 2 0C17.8 42.6 32 27.4 32 15.8 32 7.1 24.8 0 16 0Z"
          fill="currentColor"
        />
        <circle cx="16" cy="15.8" r="6" fill="#101C24" />
      </svg>
      ON MY WAY
    </button>
  );
}
